import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useId } from '@reach/auto-id';
import React, { useContext } from 'react';
export var useToggleRevealContainer = function useToggleRevealContainer(expandSingleSection) {
  var _React$useState = React.useState({}),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      openItems = _React$useState2[0],
      setOpenItems = _React$useState2[1];

  var toggleOpenItem = React.useCallback(function (itemId) {
    if (expandSingleSection) {
      setOpenItems(function (prevOpenItems) {
        return _defineProperty({}, itemId, !prevOpenItems[itemId]);
      });
    } else {
      setOpenItems(function (prevOpenItems) {
        return _objectSpread(_objectSpread({}, prevOpenItems), {}, _defineProperty({}, itemId, !prevOpenItems[itemId]));
      });
    }
  }, [setOpenItems, expandSingleSection]);
  var setOpenItem = React.useCallback(function (itemId) {
    var open = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    // when opening one section closes others
    if (expandSingleSection) {
      setOpenItems(function (prevOpenItems) {
        // if new state is closed
        if (!open) {
          // return old state if the section is already closed
          if (!prevOpenItems[itemId]) return prevOpenItems; // return new state with this section closed

          var newOpenItems = _objectSpread({}, prevOpenItems);

          delete newOpenItems[itemId];
          return newOpenItems;
        } // if new state is open


        if (Object.keys(prevOpenItems).some(function (key) {
          return key !== itemId && prevOpenItems[key];
        })) {
          // if there are other open sections close them all
          // and set this one as the only one open
          return _defineProperty({}, itemId, true);
        } else if (prevOpenItems[itemId]) {
          // if there are no other open sections and this one is
          // already open just return the old state
          return prevOpenItems;
        } else {
          // there are no sections open so return a new state
          // with this section open
          return _defineProperty({}, itemId, true);
        }
      });
    } else {
      // when sections open independently
      setOpenItems(function (prevOpenItems) {
        if (!!prevOpenItems[itemId] === !!open) {
          return prevOpenItems;
        } else {
          return _objectSpread(_objectSpread({}, prevOpenItems), {}, _defineProperty({}, itemId, open));
        }
      });
    }
  }, [expandSingleSection]);
  return {
    openItems: openItems,
    setOpenItem: setOpenItem,
    toggleOpenItem: toggleOpenItem
  };
};
export var useToggleRevealItem = function useToggleRevealItem(_ref4) {
  var onOpen = _ref4.onOpen,
      onClose = _ref4.onClose,
      open = _ref4.open,
      _id = _ref4.id;
  var autoId = useId();
  var id = _id !== null && _id !== void 0 ? _id : autoId;
  var onOpenHandler = React.useRef();
  var onCloseHandler = React.useRef();

  if (onOpenHandler.current !== onOpen) {
    onOpenHandler.current = onOpen;
  }

  if (onCloseHandler.current !== onClose) {
    onCloseHandler.current = onClose;
  }

  var _useToggleRevealConta = useToggleRevealContainerState(),
      openItems = _useToggleRevealConta.openItems,
      setOpenItem = _useToggleRevealConta.setOpenItem,
      toggleOpenItem = _useToggleRevealConta.toggleOpenItem;

  var isOpen = openItems && !!openItems[id];
  var extToggleOpen = React.useCallback(function () {
    if (!isOpen) {
      onOpenHandler.current && onOpenHandler.current();
    } else {
      onCloseHandler.current && onCloseHandler.current();
    }

    toggleOpenItem(id);
  }, [id, toggleOpenItem, isOpen]);
  React.useEffect(function () {
    if (open) {
      setOpenItem(id);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [id]); // SSR handling for isOpen

  return {
    extToggleOpen: extToggleOpen,
    isOpen: (typeof window === "undefined" ? "undefined" : _typeof(window)) !== 'object' ? open : isOpen
  };
};
export var ToggleRevealContainerContext = /*#__PURE__*/React.createContext({
  openItems: {}
});
export var ToggleRevealItemContext = /*#__PURE__*/React.createContext({
  isOpen: false,
  handleToggle: function handleToggle() {}
});
export var useToggleRevealContainerState = function useToggleRevealContainerState() {
  var contextValue = useContext(ToggleRevealContainerContext);
  return contextValue;
};